import { useQuery } from "@tanstack/react-query";

// export function useAuth() {
//   const { data: user, isLoading } = useQuery({
//     queryKey: ["/api/auth/user"],
//     retry: false,
//   });

//   return {
//     user,
//     isLoading,
//     isAuthenticated: !!user,
//   };
// }

export function useAuth() {
  const hasSupplierSession =
    typeof window !== "undefined" &&
    Boolean(localStorage.getItem("SUPPLIER_ID"));
  const hasApproverSession =
    typeof window !== "undefined" &&
    Boolean(localStorage.getItem("approverId"));

  const isAuthenticated = hasSupplierSession || hasApproverSession;

  return {
    user: isAuthenticated
      ? { id: 1, role: hasApproverSession ? "approver" : "supplier" }
      : null,
    isLoading: false,
    isAuthenticated,
  };
}
